import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-reservation-list',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    TableModule,
    ButtonModule,
    TagModule,
    InputTextModule,
    SelectModule,
    FormsModule
  ],
  templateUrl: './reservation-list.html',
  styleUrl: './reservation-list.scss'
})
export class ReservationList implements OnInit {
  reservations: any[] = [];
  loading = true;
  searchTerm = '';
  statusFilter = '';

  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Interested', value: 'INTERESTED' },
    { label: 'Converted', value: 'CONVERTED' },
    { label: 'Not Interested', value: 'NOT_INTERESTED' },
    { label: 'Expired', value: 'EXPIRED' }
  ];

  constructor(private router: Router) {}

  ngOnInit() {
    this.loadReservations();
  }

  loadReservations() {
    this.loading = true;
    // TODO: Replace with actual service call
    setTimeout(() => {
      this.reservations = [];
      this.loading = false;
    }, 1000);
  }

  getStatusSeverity(status: string): string {
    switch (status) {
      case 'CONVERTED':
        return 'success';
      case 'INTERESTED':
        return 'warning';
      case 'PENDING':
        return 'info';
      case 'NOT_INTERESTED':
        return 'danger';
      case 'EXPIRED':
        return 'secondary';
      default:
        return 'info';
    }
  }

  onViewReservation(reservationId: string) {
    this.router.navigate(['/admin/view-reservation', reservationId]);
  }

  onAddReservation() {
    this.router.navigate(['/admin/add-reservation']);
  }

  onScheduleInteraction(reservationId: string) {
    this.router.navigate(['/admin/shedule-interaction', reservationId]);
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }
}




